import _, { isArray } from "lodash";
import numeral from "numeral";
import { useMemo } from "react";
import { useBalanceStore } from "../../../_store/balanceStore";
import { useInvestStore } from "../../../_store/investStore";
import { DonutChartInvestMain } from "../../../components/chart/DonutChartMain";
import { cn } from "../../../utils/useFunctions";
import { key_property_invest_category } from "../../balance/functions";
import { PdfCard, PdfCardWhite } from "../component/pdf.c.card";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import {
  STYLE_PAGE,
  STYLE_PDF_TEXT_MEDIUM_11,
  STYLE_PDF_TEXT_NORMAL_11,
} from "../styles/pdf.style";

const getRandomHexColor = () => {
  const randomColor = `#${Math.floor(Math.random() * 16777215)
    .toString(16)
    .padStart(6, "0")}`;
  return randomColor;
};

function PdfPageInvestFour({ page, balanceData, investData }) {
  const result = investData?.sum_score;

  const investItems = useMemo(() => {
    const DebtInvestLists = balanceData?.debt_long_list
      ?.map((item) => {
        if (item?.options_debt_long === "debt_long_other") {
          let tempOthers = item.debt_long_others?.flat();
          tempOthers = tempOthers?.map((other) => ({
            ...other,
            options_debt_long: "debt_long_other",
          }));
          return tempOthers;
        }

        if (item?.options_debt_long === "debt_place") {
          let tempPlaces = item.debt_long_places?.flat();
          tempPlaces = tempPlaces?.map((place) => ({
            ...place,
            options_debt_long: "debt_place",
          }));
          return tempPlaces;
        }

        if (item?.options_debt_long === "debt_car") {
          let tempCars = item.debt_long_cars?.flat();
          tempCars = tempCars?.map((car) => ({
            ...car,
            options_debt_long: "debt_car",
          }));
          return tempCars;
        }
        return null;
      })
      ?.flat()
      .filter((item) => item?.personal_or_investment === "investment")
      .filter((item) => item?.target_invest?.label === "เพื่อการศึกษาบุตร");

    

    if (
      !balanceData?.property_invest_list?.length &&
      DebtInvestLists?.length === 0
    )
      return [];

    const filterPropertyInvest = balanceData?.property_invest_list?.filter(
      (item) => item?.options_property_invest_category
    );

    const groupInvest = _.groupBy(
      filterPropertyInvest,
      "options_property_invest_category"
    );


    
    let totalGlobal = Object.keys(groupInvest)
      ?.map((key) => {
        let tempTotal = 0;

        groupInvest[key].forEach((curr) => {
          const itemKeys = Object.keys(curr);
          for (const itemKey of itemKeys) {
            const itemValue = curr[itemKey];
            if (_.isArray(itemValue)) {
              tempTotal += itemValue?.filter((item)=> item?.target_invest?.value === "property_invest_education")?.reduce((prev, curr) => {
                return prev + curr.amount;
              }, 0);
            }
          }
        });
        return tempTotal;
      })
      ?.reduce((prev, curr) => prev + curr, 0);

    totalGlobal += DebtInvestLists?.reduce((prev, curr) => {
      return prev + Number(curr?.current_price || 0);
    }, 0);

    const convertGroupInvest = Object.keys(groupInvest)?.map((key) => {
      const items = [];
      groupInvest[key].forEach((curr) => {
        const itemKeys = Object.keys(curr);
        for (const itemKey of itemKeys) {
          const itemValue = curr[itemKey];
          if (_.isArray(itemValue)) {
            const merge = itemValue
              .filter(
                (thisItem) =>
                  thisItem?.target_invest?.value === "property_invest_education"
              )
              ?.map((thisItem) => {
                return {
                  ...thisItem,
                  label: thisItem?.title,
                  value: (thisItem?.amount / totalGlobal) * 100,
                };
              });
            items.push(...merge);
          }
        }
      }, []);
      return {
        key,
        label: key_property_invest_category[key],
        items,
      };
    });


    // MERGE ITEMS
    let mergeItems = [];
    for (const convertGroupInvestItem of convertGroupInvest) {
      mergeItems.push(
        ...convertGroupInvestItem.items?.map((item) => {
          return {
            ...item,
            title: convertGroupInvestItem.label,
            value: (item?.amount / totalGlobal) * 100,
          };
        })
      );
    }

    if (DebtInvestLists?.length > 0 && isArray(DebtInvestLists)) {
      for (const DebtInvestList of DebtInvestLists) {
        let nameMapHeader = {
          debt_place: "อสังหาริมทรัพย์",
          debt_car: "ยานพาหนะ",
          debt_long_other: "อื่นๆ",
        };
        mergeItems.push({
          color: getRandomHexColor(),
          amount: DebtInvestList.current_price,
          reward_amount_per_year: DebtInvestList.return_interest,
          title:
            nameMapHeader[DebtInvestList?.options_debt_long] || "การลงทุนอื่นๆ",
          label:
            DebtInvestList.title ||
            DebtInvestList.address_place ||
            DebtInvestList.registration_car,
          value: (DebtInvestList?.current_price / totalGlobal) * 100,
        });
      }
    }

    return mergeItems;
  }, [balanceData]);


  return (
    <div className="flex flex-col space-y-2">
      <div className={cn(STYLE_PAGE)}>
        <PdfHeader />
        <PdfLine />
        <PdfHeaderText title="การจัดทัพการลงทุน" icon="/images/revenue.svg" />
        {/* การจัดทัพการลงทุน */}
        <PdfCard
          title={`สัดส่วนการลงทุนเพื่อการศึกษาบุตร`}
          title2={`(เป็นเพียงการแสดงสัดส่วนการลงทุนแยกตามประเภทเป้าหมายการลงทุน)`}
          className={"flex flex-col space-y-3"}
          classNameTitle={"text-left"}
        >
          <PdfCardWhite className={cn("flex space-x-2 justify-center")}>
            <DonutChartInvestMain
              classNameRoot={cn("flex")}
              className={cn("w-[140px] h-[140px] pt-0")}
              classNameDetail={cn("space-y-1")}
              classNameText={cn(STYLE_PDF_TEXT_NORMAL_11)}
              width={20}
              height={20}
              sectionFrom="PdfPageInvestFour"
              items={investItems}
            />
            {/* <div className={cn(STYLE_PDF_TEXT_MEDIUM_11)}>1</div> */}
          </PdfCardWhite>
        </PdfCard>
        <PdfCard>
          <PdfCardWhite className={cn("flex flex-col")}>
            <div className={cn("flex", STYLE_PDF_TEXT_MEDIUM_11)}>
              <div className={cn("w-[20%]")}>หัวข้อ</div>
              <div className={cn("w-[25%]")}>รายการ</div>
              <div className={cn("w-[20%]")}>มูลค่าปัจจุบัน</div>
              <div className={cn("w-[15%]")}>ผลตอบแทน (%)</div>
              <div className={cn("w-[20%] text-right")}>สัดส่วน</div>
            </div>
            <div className={cn("border border-b border-mainblue mt-1")}></div>
            <div className="mt-2 flex flex-col space-y-2">
              {investItems?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={cn("flex", STYLE_PDF_TEXT_MEDIUM_11)}
                  >
                    <div className={cn("w-[20%]")}>{item?.title}</div>
                    <div className={cn("w-[25%]")}>{item?.label}</div>
                    <div className={cn("w-[20%]")}>
                      {numeral(item?.amount).format("0,0")}
                    </div>
                    <div className={cn("w-[15%]")}>
                      {numeral(item?.reward_amount_per_year).format("0.00")}
                    </div>
                    <div className={cn("w-[20%] text-right")}>
                      {numeral(item?.value).format("0.00")}%
                    </div>
                  </div>
                );
              })}
            </div>
          </PdfCardWhite>
        </PdfCard>
        <PdfFooter page={page} />
      </div>
    </div>
  );
}

export default PdfPageInvestFour;
